/* eslint-disable jsx-a11y/anchor-is-valid */
//referrent : https://github.com/autumnchris/countdown-timer
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { KPISummaryService, TableDto } from 'app/modules/core'
import { DateFlipDown } from 'app/components'

const GradeBroadPage: FC = () => {
  const [data, setData] = useState<TableDto>()

  useEffect(() => {
    const init = () => {

      KPISummaryService.GetLastAssess().then(res => {
        setData(res.data.result)
      })
    }
    init()
  }, [])


  const renderItems = (data: TableDto) => {
    const result = [];
    for (let index = 5; index < data.rows.length; index++) {
      result.push(<div key={index} className='row'>
        <div className='col-6 '>{data.rows[index][0]}</div>
        <div className='col-6 d-flex justify-content-end'>{data.rows[index][1]}&nbsp;pt.</div>

      </div>)
    }

    return result
  }

  const checkDayClose = (dateEnd: string) => {
    const d = new Date(dateEnd)
    if (d > new Date()) {
      return <DateFlipDown periodend={dateEnd} />
    }  
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}></PageTitle>
      {/* begin::Row */}
      <div className='row gy-5 g-xl-8 justify-content-center'>
        <div className='card cursor-pointer'>
          <div className='card-body p-9'><div className="d-flex flex-column mb-3">
            <div className="d-flex justify-content-center"><h2 >เกรดการประเมินล่าสุดของคุณคือ</h2></div>
            <div className="d-flex justify-content-center"><h1 className='text-primary'>{data && data.rows.length > 0 ? data.rows[0][1] : ""}</h1></div>
            <div className="d-flex justify-content-center"><h3>ลำดับการประเมินของอยู่ที่</h3></div>
            <div className="d-flex justify-content-center">{data && data.rows.length > 0 ? data.rows[1][1] : `0 จาก 0`}</div>
            <div className="d-flex justify-content-center"><h3>คะแนนรวมการประเมินอยู่ที่</h3></div>
            <div className="d-flex justify-content-center">{`${data && data.rows.length > 0 ? data.rows[2][1] : 0} คะแนน`}</div>

            {data && renderItems(data)}
            <div className="d-flex justify-content-center"><strong>สถานะการประเมิน</strong>&nbsp;<span className='text-danger'>{data && data.rows.length > 0 ? data.rows[3][1] : ''}</span></div>
            <div className="d-flex justify-content-center"><strong>สิ้นสุดการประเมินในวันที่</strong></div>
            <div className="d-flex justify-content-center">{`${data && data.rows.length > 0 ? data.rows[4][1] : ''} `}</div>
            <div className="d-flex justify-content-center"> {data && data.rows.length > 0 ? checkDayClose(data.rows[4][1]) : ''}</div>
          </div></div>
        </div>

      </div>
      {/* end::Row */}
    </>
  )
}
export { GradeBroadPage }
